import React from 'react'
import PropTypes from 'prop-types'

const FooterNav = ({ title, links }) => (
  <div className="w-32 mb-8 md:m-0">
    <div className="font-bold text-white mb-6">{title}</div>
    <div className="block">
      {links.map(({ label, to, ...rest }, index) => (
        <a
          key={`${to}-${index}`}
          target="_blank"
          rel="noreferrer"
          href={to}
          className="block font-bold secondary-text text-white opacity-50 hover:text-white hover:opacity-100 mb-3"
          {...rest}
        >
          {label}
        </a>
      ))}
    </div>
  </div>
)

FooterNav.propTypes = {
  title: PropTypes.string.isRequired,
  links: PropTypes.array.isRequired,
}

export default FooterNav
